import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';

Snappy.Component.ResponsiveImage = class ResponsiveImage extends Snappy.BaseComponent {
    static get tagName() {
        return 'responsive-image';
    }

    constructor(element) {
        super(element);
    }

    setOptions() {
        this.Options = {
            smallImage: this.$element.data('small-image'),
            mediumImage: this.$element.data('medium-image'),
            image: this.$element.data('image'),
            largeImage: this.$element.data('large-image')
        }
    }

    setEventListeners() {
        window.addEventListener('resize', this.loadImage.bind(this));
    }

    loadImage() {
        var defaults = {};
        var settings = $.extend(this.Options, defaults);

        if ($(window).width() <= 360) {
            this.$element.find("img").attr("src", settings.smallImage);
        }
        else if ($(window).width() <= 670 && $(window).width() > 361) {
            this.$element.find("img").attr("src", settings.mediumImage);
        }
        else if ($(window).width() <= 1440 && $(window).width() > 669) {
            this.$element.find("img").attr("src", settings.image);
        }
        else if ($(window).width() >= 1441) {
            this.$element.find("img").attr("src", settings.largeImage);
        }

    }
    
    render() {
        this.setOptions();
        this.loadImage();
        this.setEventListeners();
    }

    
    
}






// WEBPACK FOOTER //
// ./components/responsiveImage/scripts/responsive-image.js